import ApiClient from './ApiClient'

const client = new ApiClient()
const USER_ID = process.env.VUE_APP_USER_ID
const USER_TOKEN = process.env.VUE_APP_USER_TOKEN

export default {
  /**
   * サインインしているユーザーの取得
   */
  getUserWorks: () => {
    return client.get(`/users/${USER_ID}/works?user_token=${USER_TOKEN}`)
  }
}
